import content from "../../content.json";
import * as classes from "./landing-page.module.scss";
import {
  ActionType,
  AppContext,
  ViewMode,
  World,
} from "../../contexts/AppContext";
import { useContext } from "react";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import PictureNiceLoader from "../PictureNiceLoader/PictureNiceLoader";
import { landing } from "../../images/index";
import FutureNature from "../../icons/FutureNature.svg";
import VideoBackground from "../VideoBackground/VideoBackground";
import backgroundSrc from "url:../../videos/CBCA-Start-Screen-Video_16x9.mp4";
import backgroundSrcPortrait from "url:../../videos/CBCA-Start-Screen-Video_9x16.mp4";
import Button from "../Button/Button";

const LandingPage = () => {
  const { state, dispatch } = useContext(AppContext);
  const { viewMode } = state;
  return (
    <TransitionGroup component={null}>
      {viewMode === ViewMode.LandingPage ? (
        <CSSTransition key="landing-page" timeout={333}>
          <div className={classes.root}>
            <PictureNiceLoader
              className={classes.image}
              src={landing.src}
              sources={[
                {
                  srcSet: landing.srcSetLandscape.jpg,
                  type: "image/jpeg",
                  media: "(orientation: landscape)",
                },
                {
                  srcSet: landing.srcSetLandscape.webp,
                  type: "image/webp",
                  media: "(orientation: landscape)",
                },
                {
                  srcSet: landing.srcSetPortrait.jpg,
                  type: "image/jpeg",
                  media: "(orientation: portrait)",
                },
                {
                  srcSet: landing.srcSetPortrait.webp,
                  type: "image/webp",
                  media: "(orientation: portrait)",
                },
              ]}
              alt=""
              sizes="100vw"
            />
            <VideoBackground
              className={classes.video}
              src={backgroundSrc}
              srcPortrait={backgroundSrcPortrait}
            />
            <div className={classes.shim} aria-hidden={true}></div>
            <div className={classes.inner}>
              <FutureNature className={classes["future-nature"]} />
              <h2
                style={{
                  opacity: 0,
                  pointerEvents: "none",
                  position: "absolute",
                }}
              >
                Future Nature
              </h2>
              <div className={classes.intro}>
                <p
                  dangerouslySetInnerHTML={{
                    __html: content.uiCopy.landingPageIntro,
                  }}
                ></p>
              </div>
              <div className={classes.options}>
                <Button
                  type="button"
                  size="large"
                  label={content.uiCopy.exploreWorld}
                  onClick={() =>
                    dispatch({
                      type: ActionType.SetWorld,
                      value: World.FieldTrip,
                    })
                  }
                />
                <Button
                  type="button"
                  size="large"
                  label={content.uiCopy.browseCollection}
                  onClick={() =>
                    dispatch({
                      type: ActionType.SetViewMode,
                      value: ViewMode.Lookbook,
                    })
                  }
                />
              </div>
            </div>
          </div>
        </CSSTransition>
      ) : null}
    </TransitionGroup>
  );
};

export default LandingPage;
